import { Box, Stack, Typography } from "@mui/material";
import StyledPage from "../infoPage/StyledPage";
import AuthLoaderSvg from "./AuthLoaderSvg";

interface Props {
  title: string;
  subtitle: string;
}

const FullScreenLoader = ({ title, subtitle }: Props) => (
  <StyledPage>
    <Box sx={{ mt: -20, width: 240 }}>
      <AuthLoaderSvg />
    </Box>
    <Stack spacing={1} sx={{ alignItems: "center" }}>
      <Typography variant="h3">{title}</Typography>
      <Typography>{subtitle}</Typography>
    </Stack>
  </StyledPage>
);

export default FullScreenLoader;
